import React from 'react'
import { ExperimentOutlined } from '@ant-design/icons'

import { useCaseViewContext } from '../../../context'
import { StyledButton } from '../../Button'
import { REQUEST_STATUS, TELEMEDICINE_CATEGORIES, CaseStatusEnum } from '../../../constants'

const getCategorySlug = (caseDetails) => {
  return caseDetails?.category?.slug
    || caseDetails?.categoryName?.toLowerCase()
    || caseDetails?.category?.name?.toLowerCase()
    || caseDetails?.teleMedicineCategory?.name?.toLowerCase()
}

const isCategoryMatch = (caseDetails, categoryConfig) => {
  const slug = getCategorySlug(caseDetails)
  const categoryId = caseDetails?.categoryId

  if (categoryConfig.categoryId && categoryId === categoryConfig.categoryId) return true
  if (slug === categoryConfig.name) return true
  return false
}

export const isLabEligibleCategory = (caseDetails) => {
  return isCategoryMatch(caseDetails, TELEMEDICINE_CATEGORIES.TESTOSTERONE) 
    || isCategoryMatch(caseDetails, TELEMEDICINE_CATEGORIES.SERMORELIN)
}

export const isSermorelinCategory = (caseDetails) => {
  return isCategoryMatch(caseDetails, TELEMEDICINE_CATEGORIES.SERMORELIN)
}

export const Labs = ({ setShowLabOrderModal, readOnlyMode = false }) => {
  const { caseDetails } = useCaseViewContext()
  const activeRequest = caseDetails?.requests?.at(-1)

  const isLabEligible = isLabEligibleCategory(caseDetails)
  const isSermorelin = isSermorelinCategory(caseDetails)
  const caseHasLabsInProgress = [
    CaseStatusEnum.PENDING_LABS,
  ].includes(caseDetails?.status)
  const requestHasLabStatus = [
    REQUEST_STATUS.PENDING_LAB_ORDER,
    REQUEST_STATUS.PENDING_LAB_RESULTS,
  ].includes(activeRequest?.status)
  const hasLabResults = activeRequest?.labResults?.length > 0

  if (!isLabEligible) return null
  if (isSermorelin && !caseHasLabsInProgress && !requestHasLabStatus && !hasLabResults) return null

  const labsStatus = activeRequest?.status === REQUEST_STATUS.PENDING ? REQUEST_STATUS.COMPLETED : activeRequest?.status || 'unknown'
  
  const canOrderLabs = !readOnlyMode

  return (
    <div style={{ 
      width: '100%', 
      padding: '20px',
      marginBottom: '20px', 
      background: 'rgba(204, 125, 203, 0.15)', 
      color: '#000',
      borderRadius: '5px', 
      display: 'flex',
      flexDirection: 'column',
      gap: '5px'
    }}>
      <div style={{ width: '100%', display: 'flex'}}>
        <div style={{ display: 'flex', width: '100%'}}>
          <div style={{ width: 'calc(100% - 100px)' }}>
            <strong style={{ color: 'rgba(204, 125, 203, 1)', fontSize: '1.1rem' }}>Metabolic Lab Test</strong>
          </div>
          <div style={{ width: '100px', display: 'flex', justifyContent: 'flex-end', gap: '3px', }}>
            {canOrderLabs ? (
              <StyledButton 
                onClick={() => setShowLabOrderModal(true)}
                size='small' 
                Icon={ExperimentOutlined} 
                color='rgba(204, 125, 203, 1)'
                tooltip="Order labs"
              />
            ) : (
              <StyledButton 
                onClick={() => setShowLabOrderModal(true)}
                size='small' 
                Icon={ExperimentOutlined} 
                color='rgba(204, 125, 203, 1)'
                tooltip="View lab documents"
              />
            )}
          </div>
        </div>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '5px'}}>
        <span><strong>Description:</strong> Testosterone Replacement Lab Panel</span>
        <span><strong>Status:</strong> {labsStatus}</span>
      </div>
    </div>
  )
}
